"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboBoxNew = void 0;
var Algemeen = require("./Algemeen");
var Aanvraag = require("./Aanvraag");
var Algemeen_1 = require("./Algemeen");
function ComboBoxNew($tb, classItem, classItemInFocus, webServiceFunctionName, AllowFreeText, AllowBlanc, InitSelectedValue) {
    var _self = this;
    this.$tb = $tb;
    var ajaxPrefix = 'ctl00_cphBody_tb';
    var tbId = $tb[0].id.substring(ajaxPrefix.length);
    //this.pce = $find('ctl00_cphBody_pce' + tbId);
    this.$pnl = $('#ctl00_cphBody_pnl' + tbId);
    Algemeen.PopupControl(this.$tb, this.$pnl);
    this.DisableKeyUp = false;
    this.$tb.keyup(function (e) { tbOnkeyup(e); });
    this.$tb.keydown(function (e) { tbOnkeydown(e); });
    this.$tb.focus(function () { tbOnfocus(); });
    this.$tb.blur(function () { _self.tbOnblur(); });
    this.$pnl.mousedown(function () { pnlOnmousedown(); });
    this.webServiceFunctionName = webServiceFunctionName;
    this.classItem = classItem;
    this.classItemInFocus = classItemInFocus;
    this.dataAll;
    this.AllowFreeText = AllowFreeText;
    this.AllowBlanc = AllowBlanc;
    this.selectedValue = '';
    this.InitSelectedValue = InitSelectedValue;
    this.InitSelectedText = undefined;
    function tbOnkeyup(e) {
        if (!_self.DisableKeyUp) {
            if (_self.FilterAndFill != undefined) {
                _self.FilterAndFill();
                _self.$tb.blur(function () { _self.tbOnblur(); });
            }
        }
    }
    function tbOnkeydown(e) {
        Algemeen.KeyDown(e, _self);
    }
    function tbOnfocus() {
        if (_self.FilterAndFill != undefined) {
            _self.FilterAndFill();
        }
    }
    this.tbOnblur = function () {
        _self.ItemToTb(_self.OnblurTbItem(_self.$tb.val()));
        _self.hidePopup();
    };
    function pnlOnmousedown() {
        _self.$tb.off('blur');
    }
    this.CallWebService = function () {
        $.ajax({
            type: "POST",
            url: "Aanvraag.asmx/" + _self.webServiceFunctionName,
            data: "{}",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data, status) { _self.WebServiceOnSuccess(_self, data, status); },
            error: Algemeen.OnErrorCallWebService
        });
    };
    this.WebServiceOnSuccess = function (cb, data, status) {
        cb.dataAll = data.d;
        cb.fillDropDown(data.d);
        if (cb.InitSelectedValue == undefined) {
            if (cb.InitSelectedText == undefined) {
                if (!AllowBlanc) {
                    _self.ItemToTb(_self.dataAll[0]);
                }
            }
            else {
                _self.SetSelectedText(cb.InitSelectedText);
            }
        }
        else {
            _self.SetSelectedValue(cb.InitSelectedValue);
        }
        _self.RunAfterWebServiceOnSuccess();
        _self.Loaded = true;
        Aanvraag.CheckAllLoaded();
    };
    this.pnlOnClick = function (Code, Description) {
        _self.$tb.val(Description);
        _self.selectedValue = Code;
        _self.hidePopup();
    };
    this.AddItem = function (Item) {
        var $div = $('<div class="divDropDownItem">' + Item.Description + '</div>');
        $div.click(function (e) { _self.pnlOnClick(Item.Code, Item.Description); });
        $div.mouseover(function () { _self.pnlOnMouseover(this); });
        _self.$pnl.append($div);
    };
}
exports.ComboBoxNew = ComboBoxNew;
ComboBoxNew.prototype.showPopup = function () {
    this.$pnl.css('left', this.$tb.position().left);
    this.$pnl.css('top', this.$tb.position().top + this.$tb.outerHeight());
    this.$pnl.css('visibility', 'visible');
};
ComboBoxNew.prototype.hidePopup = function () {
    this.$pnl.css('visibility', 'hidden');
};
ComboBoxNew.prototype.InitSelectedValue;
ComboBoxNew.prototype.ItemToTb = function (Item) {
    this.$tb.val(Item.Description);
    this.selectedValue = Item.Code;
};
ComboBoxNew.prototype.pnlOnMouseover = function (div) {
    this.$pnl.find('.' + this.classItemInFocus).removeClass(this.classItemInFocus);
    $(div).addClass(this.classItemInFocus);
};
ComboBoxNew.prototype.Init = function () {
    this.CallWebService();
};
ComboBoxNew.prototype.fillDropDown = function (Items) {
    this.$pnl.empty();
    for (var i = 0; i < Items.length; i++) {
        this.AddItem(Items[i]);
    }
};
//FILTER DATA
ComboBoxNew.prototype.FilterAndFill = function () {
    var Items = this.Filter(this.$tb.val());
    if (Items.length == 0) {
        this.hidePopup();
    }
    else {
        this.showPopup();
    }
    this.fillDropDown(Items);
};
//FILTER DATA
ComboBoxNew.prototype.Filter = function (filter) {
    var filteredItems = new Array();
    for (var i = 0; i < this.dataAll.length; i++) {
        var Item = this.dataAll[i];
        // if (Item.Description.toLowerCase().indexOf(filter.toLowerCase()) == -1 || filter == "") { //We show all options now in combobox, previously selected item was not shown
        filteredItems.push(Item);
        // }
    }
    return filteredItems;
};
//EVENTS
ComboBoxNew.prototype.OnblurTbItem = function (tbValue) {
    var Item;
    if (this.AllowFreeText) {
        Item = new this.CItem();
        Item.Description = tbValue;
    }
    else {
        for (var i = 0; i < this.dataAll.length; i++) {
            Item = this.dataAll[i];
            if (Item.Description.toLowerCase() == tbValue.toLowerCase()) {
                return Item;
            }
        }
        if (this.AllowBlanc) {
            Item = new this.CItem();
        }
        else {
            var filteredItems = this.Filter(tbValue);
            if (filteredItems.length == 0) {
                Item = this.dataAll[0];
            }
            else {
                Item = filteredItems[0];
            }
        }
    }
    return Item;
};
ComboBoxNew.prototype.CItem = function () {
    this.Code = '';
    this.Description = '';
};
ComboBoxNew.prototype.SetSelectedValue = function (value) {
    this.selectedValue = value;
    for (var i = 0; i < this.dataAll.length; i++) {
        if (this.dataAll[i].Code == value) {
            this.$tb.val(this.dataAll[i].Description);
            break;
        }
    }
};
ComboBoxNew.prototype.SetSelectedText = function (value) {
    try {
        this.$tb.val(value);
        for (var i = 0; i < this.dataAll.length; i++) {
            if (this.dataAll[i].Description == value) {
                this.selectedValue = this.dataAll[i].Code;
                break;
            }
        }
    }
    catch (err) {
        (0, Algemeen_1.ErrorHandler)(err);
    }
};
ComboBoxNew.prototype.RunAfterWebServiceOnSuccess = function () { };
ComboBoxNew.prototype.Loaded = false;
